import React, { Component } from 'react'
import './CustomLink.css'

export default class CustomLink extends Component {
	render() {

		let { link, title } = this.props

		return (
			<div className='customLink'>
				<div className='background'/>
				<a href={link}>{title}</a>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/CustomLink.js